import React from "react";
import { FieldHeading } from "./FieldHeading.js";
import { FieldItem } from "./FieldItem.js";
import { QueryItem } from "../../../model/accounting/query/QueryItem.js";

type Props = {
  services: number;
  servicesItems: QueryItem[];
};

/**
 * Generates table rows for the VAT report field 3.
 */
export const VatReportField3 = ({ services, servicesItems }: Props) => {
  return (
    <>
      <FieldHeading
        label="Väli 3"
        description="0% määraga maksustatavad toimingud ja tehingud."
        total={services}
        itemsCount={servicesItems.length}
      />
      {servicesItems.map((queryItem) => (
        <FieldItem key={queryItem.id} queryItem={queryItem} />
      ))}
    </>
  );
};
